import { css } from "styled-components";

import { focusBoxShadow } from "core/links";

export const handleStyleType = ({ styleType, STYLE_TYPES }) => {
    switch (styleType) {
        case "outline":
            return STYLE_TYPES.OUTLINE;
        case "cta":
            return STYLE_TYPES.CTA;
        case "text":
            return STYLE_TYPES.TEXT;
        case "none":
            return STYLE_TYPES.NONE;
        case "solid":
            return STYLE_TYPES.SOLID;
        default:
            return STYLE_TYPES.SOLID;
    }
};

export const handleBoxShadowOutlineBorder = ({
    size,
    color,
    hasFocusShadow = false
}) => {
    if (hasFocusShadow) {
        return css`
            ${`inset 0px 0px 0px ${
                size === "lg" ? "2px" : "1px"
            } ${color}, ${focusBoxShadow}`}
        `;
    }

    return css`
        ${`inset 0px 0px 0px ${size === "lg" ? "2px" : "1px"} ${color}`}
    `;
};
